import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    registry: [],
    sources: {
        log: true,
    },
    apiHealthData: {},
};
const logSlice = createSlice({
    name: 'log',
    initialState,
    reducers: {
        addLog: {
            reducer: (state, action) => {
                state.registry.push(action.payload);
                // Set source to true if not explicitly set to false
                if (state.sources[action.payload.source] === undefined) {
                    state.sources[action.payload.source] = true;
                }
            },
            prepare: (message, logType = 'info', source = 'default') => ({
                payload: {
                    message,
                    logType,
                    timestamp: Date.now(),
                    source,
                },
            }),
        },
        toggleSource: (state, action) => {
            state.sources[action.payload] = !state.sources[action.payload];
        },
        resetLogs: () => initialState,
        addAPIHealthData: (state, action) => {
            state.apiHealthData = action.payload;
        },
    },
});
// Export actions - maintains backward compatibility
export const { addLog, toggleSource, resetLogs, addAPIHealthData } = logSlice.actions;
// Export reducer as default - maintains backward compatibility
export default logSlice.reducer;
